export default __webpack_public_path__ + "static/media/hour-glass.4144ec38.png";